import React, { Component } from 'react'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'
import posed, { PoseGroup } from 'react-pose'

const PosedDiv = posed.div({
  preEnter: {
    opacity: 0,
    x: 50
  },

  enter: {
    opacity: 1,
    x: 0
  },
  
  exit: {
    opacity: 0,
    x: -50
  }
})

const Wrapper = styled.div`
  width: 100%;
  position: relative;
`

const ImageContainer = styled(PosedDiv)`
  background: url(${props => props.image}) center / cover;
  width: 100%;
  height: 0;
  padding-bottom: 45%;

  ${media.xs`
    padding-bottom: 70%;
  `}

  ${media.lg`
    padding-bottom: 70%;
  `}
`

export default class Image extends Component {
  render() {
    const { image } = this.props

    return(
      <Wrapper>
        <PoseGroup
          preEnterPose="preEnter"
          withParent={false}
        >
          <ImageContainer
            key={Math.random()}
            image={image}
          />
        </PoseGroup>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/DaySlider/Image.js